<template>
  <div class="modal topup-modal sell-skin-modal">
    <div class="overlay" @click="closeSellSkinModal" />
    <div class="wrapper">
      <button class="close" @click="closeSellSkinModal">
        <img src="@/assets/img/closeNew.svg" alt="close new" srcset="" />
      </button>
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <Form
              ref="form"
              @submit="onSubmit"
              v-slot="{ meta }"
              class="form-fields"
            >
              <div class="form-fields-wrapper">
                <div class="cart-up">
                  <div class="cart-top">
                    <div class="title text-white">
                      <b>{{ $t("Sell your skin") }}</b>
                    </div>
                  </div>
                  <div class="topup-form">
                    <div class="desc">
                      {{ $t("Check my trade link") }}
                    </div>
                    <a
                      class="desc"
                      target="_blank"
                      href="https://steamcommunity.com/my/tradeoffers/privacy"
                    >
                      https://steamcommunity.com/my/tradeoffers/privacy
                    </a>
                    <!-- Steam trade link field -->
                    <Field
                      name="steam_link"
                      :rules="{
                        regex: new RegExp(
                          '^https:\\/\\/[a-zA-Z0-9\\-\\.]+(\\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\\/.*)?$',
                        ),
                      }"
                      v-slot="{ field, errors }"
                    >
                      <label class="input-container">
                        <input
                          v-bind="field"
                          type="text"
                          required
                          :placeholder="$t('Steam trade link')"
                        />
                        <span v-if="errors.length" class="error">
                          {{ errors[0] }}
                        </span>
                      </label>
                    </Field>

                    <!-- Skin name field -->
                    <Field
                      name="skin_name"
                      rules="required"
                      v-slot="{ field, errors }"
                    >
                      <label class="input-container">
                        <input
                          v-bind="field"
                          type="text"
                          required
                          :placeholder="$t('Skin name')"
                        />
                        <span v-if="errors.length" class="error">
                          {{ errors[0] }}
                        </span>
                      </label>
                    </Field>

                    <!-- Price field with manual input filtering -->
                    <Field
                      name="price"
                      rules="required|decimal:2|min_value:0.1"
                      v-slot="{ errors }"
                    >
                      <label class="input-container">
                        <input
                          type="text"
                          :value="priceInput"
                          @input="onPriceInput"
                          @blur="onPriceBlur"
                          required
                          :placeholder="$t('Price')"
                        />
                        <span v-if="errors.length" class="error">
                          {{ errors[0] }}
                        </span>
                      </label>
                    </Field>
                  </div>
                </div>

                <div class="cart-bottom">
                  <button
                    type="submit"
                    :disabled="!meta.touched || !meta.valid"
                    :class="[
                      'button red w-130',
                      { disabled: !meta.touched || !meta.valid },
                    ]"
                  >
                    {{ $t("Submit") }}
                  </button>
                </div>

                <transition name="slide">
                  <div v-if="error" class="error-desc desc red">
                    {{ $t(error) }}
                  </div>
                </transition>
                <transition name="slide">
                  <div v-if="success" class="error-desc desc green">
                    {{ $t(success) }}
                  </div>
                </transition>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import { Form, Field } from "vee-validate";

export default {
  name: "SellSkinModal",
  components: {
    Form,
    Field,
  },
  data() {
    return {
      priceInput: "",
      success: "",
      error: "",
    };
  },
  methods: {
    closeSellSkinModal() {
      this.$emit("closeSellSkinModal");
    },

    onPriceInput(event) {
      let value = event.target.value;

      // Удаляем все кроме цифр и точки
      value = value.replace(/[^0-9.]/g, "");

      // Оставляем только одну точку
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts[1];
      }

      // Ограничиваем до 2 знаков после точки
      if (parts[1]) {
        parts[1] = parts[1].slice(0, 2);
        value = parts[0] + "." + parts[1];
      }

      // Если начинается с точки, добавляем 0 перед ней
      if (value.startsWith(".")) {
        value = "0" + value;
      }

      this.priceInput = value;

      // Обновим значение поля vee-validate вручную
      this.$refs.form.setFieldValue("price", value);
    },

    onPriceBlur() {
      // Дополнительно — убираем точку на конце при потере фокуса
      if (this.priceInput.endsWith(".")) {
        this.priceInput = this.priceInput.slice(0, -1);
        this.$refs.form.setFieldValue("price", this.priceInput);
      }
    },

    async onSubmit(values) {
      try {
        await axios.post("sell-orders", {
          skin_name: values.skin_name,
          steam_link: values.steam_link,
          price: parseFloat(this.priceInput),
        });

        this.error = "";
        this.success = "Success";

        setTimeout(() => {
          this.closeSellSkinModal();
        }, 3000);
      } catch (error) {
        if (error.response?.data?.errors) {
          this.error = error.response.data.errors;
        } else if (
          error.response?.data?.status === "ERROR" &&
          error.response?.data?.message
        ) {
          this.error = error.response.data.message;
        }
      }
    },
  },
};
</script>
